import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as RemoveCrossIcon } from '../../../assets/icons/remove-cross.svg';
import s from './FacilityButton.module.scss';

/**
 * Remove facility button
 * @param {Object} props props with click handler
 * @returns {Object} component jsx
 */
function RemoveFacilityButton(props) {
  const { onClick } = props;

  return (
    <button type="button" onClick={onClick} className={s.wrapper}>
      <RemoveCrossIcon role="presentation" focusable="false" />
      <FormattedMessage id="offerWizard.removeFacility" />
    </button>
  );
}

RemoveFacilityButton.propTypes = {
  /** click handler function */
  onClick: PropTypes.func.isRequired,
};

export default RemoveFacilityButton;
